import enLang from "./entries/en-US";
import trLang from "./entries/tr_TR";
import RuLang from "./entries/ru_RU";

const AppLocale = {
  tr: trLang,
 // en: enLang,
 // ru: RuLang,
};


export default AppLocale;
